import { Authorization, Token, UserInfo } from '@/constants/authorization';
import { DEFAULT_ROLE, UserRole } from '@/constants/roles';
import { getSearchValue } from './common-util';
const KeySet = [Authorization, Token, UserInfo];

const storage = {
  getAuthorization: () => {
    return localStorage.getItem(Authorization);
  },
  getToken: () => {
    return localStorage.getItem(Token);
  },
  getUserInfo: () => {
    return localStorage.getItem(UserInfo);
  },
  getUserInfoObject: () => {
    try {
      return JSON.parse(localStorage.getItem('userInfo') || '{}');
    } catch (e) {
      return {};
    }
  },
  getUserRole: (): UserRole => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      // Map numeric is_superuser: 2 -> ADMIN, 1 -> ADMIN_VIEW, 0 -> USER
      const su = Number(userInfo?.is_superuser);
      if (su === 2) return UserRole.ADMIN;
      if (su === 1) return UserRole.ADMIN_VIEW;
      if (su === 0) return UserRole.USER;
      // Fallback to role or default
      return userInfo?.role || DEFAULT_ROLE;
    } catch (e) {
      return DEFAULT_ROLE;
    }
  },
  isAdmin: (): boolean => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return Number(userInfo?.is_superuser) === 2;
    } catch (e) {
      return false;
    }
  },
  isAdminView: (): boolean => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return Number(userInfo?.is_superuser) === 1;
    } catch (e) {
      return false;
    }
  },
  setAuthorization: (value: string) => {
    localStorage.setItem(Authorization, value);
  },
  setToken: (value: string) => {
    localStorage.setItem(Token, value);
  },
  setUserInfo: (value: string | Record<string, unknown>) => {
    let valueStr = typeof value !== 'string' ? JSON.stringify(value) : value;
    localStorage.setItem(UserInfo, valueStr);
  },
  setItems: (pairs: Record<string, string>) => {
    Object.entries(pairs).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  },
  removeAuthorization: () => {
    localStorage.removeItem(Authorization);
  },
  removeAll: () => {
    KeySet.forEach((x) => {
      localStorage.removeItem(x);
    });
  },
  setLanguage: (lng: string) => {
    localStorage.setItem('lng', lng);
  },
  getLanguage: (): string => {
    return localStorage.getItem('lng') as string;
  },
};

export const getAuthorization = () => {
  const auth = getSearchValue('auth');
  const authorization = auth
    ? 'Bearer ' + auth
    : storage.getAuthorization() || '';

  return authorization;
};

export default storage;

// Will not jump to the login page
export function redirectToLogin() {
  window.location.href = location.origin + `/login`;
}
